export const ERROR_DISPLAY = 'ERRORS/DISPLAY'
export const CLEAR_SEARCH_RESULTS_ERROR = 'ERRORS/CLEAR_SEARCH_RESULTS'
